import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Link,
  Stack,
  Typography,
} from "@mui/material";

import useTitle from "../hooks/useTitle";

import { Outlet } from "react-router-dom";

const IntrusctionsCard = () => {
  return (
    <Card sx={{ mb: 2 }}>
      <CardHeader title="Instructions" />
      <CardContent>
        <Typography
          variant="body2"
          sx={{ fontWeight: 500, color: "primary.main", mb: 1 }}
        >
          Use this page to view and override CPC rates for Managed+ clients.
          Both Base and Audience Floor overrides supported for Podcast and only
          Audience Floor override supported for Pageview product.
        </Typography>
        <Typography
          variant="body2"
          component="ol"
          sx={{ fontWeight: 400, color: "text.secondary", pl: 2.5, m: 0 }}
        >
          <li>
            Enter the <b>Account ID</b>, select a <b>Product</b>, and{" "}
            <b>choose what to override (Base Floors or Audience Floors)</b>. To
            override base floor rates for Pageview, use the{" "}
            <Link href="/admin/managed_plus_accounts" underline="hover">
              Managed+ Accounts page
            </Link>
            .
          </li>
          <li>
            Click <b>‘Apply’</b> to view current rates.
          </li>
          <li>
            To modify rates, click <b>‘Update’</b> and adjust the values.
            <Box
              component="ul"
              sx={{ pl: 2.5, mt: 0.5, mb: 0, listStyleType: "disc" }}
            >
              <li>
                For Pageview audience floors,{" "}
                <b>adjust the 10s TOS value and click 'Recalculate'</b> to
                preview how the updated rate applies across the rest of the TOS.
              </li>
              <li>
                For Podcast default rates,{" "}
                <b>adjust both the 15s and 30s values directly</b>.
              </li>
            </Box>
          </li>
          <li>
            Click <b>‘Confirm’</b> to apply the new rates or <b>‘Cancel’</b> to
            discard any changes.
          </li>
        </Typography>
      </CardContent>
    </Card>
  );
};

const ManagedPlusCustomAudienceFloors = () => {
  useTitle("Custom Client Floors");

  return (
    <>
      <Stack spacing={3} sx={{ width: "75vw" }}>
        <IntrusctionsCard />
        <Stack spacing={2}>
          <Outlet />
        </Stack>
      </Stack>
    </>
  );
};

export default ManagedPlusCustomAudienceFloors;
